import { render, staticRenderFns } from "./RelatedOrders.vue?vue&type=template&id=d8b7df14"
import script from "./RelatedOrders.vue?vue&type=script&lang=js"
export * from "./RelatedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports